module.exports = __webpack_public_path__ + "img/20-2.e82d64c1.png";